import { useState } from 'react';

const SEE_MORE_LIMIT = 10;

type Props = {
  data: string[] | null;
  title: string;
  errorMsg: string;
};

export const SimpleTableSyncError: React.FC<Props> = ({ data, title, errorMsg }) => {
  const [seeMore, setSeeMore] = useState(false);
  const handleToggleSeeMore = () => {
    setSeeMore((prev) => !prev);
  };

  const dataLength = (data ?? []).length;

  if (!data || data.length === 0) return null;

  return (
    <div className="SyncResponseWrapper">
      <h4>{title}</h4>
      <p>{errorMsg}</p>
      <div className="InfoTableContainer StaticTable SyncResponse">
        <div className="LTContainer">
          <div className="InfoTable HideChkboxCol">
            <div className="MiddleTable">
              <div className="Head">
                <div className="Cell">
                  <span className="Txt">Name</span>
                </div>
              </div>
              <div className="TableBody">
                {data
                  .slice(0, seeMore ? undefined : SEE_MORE_LIMIT)
                  .map((name, index) => (
                    <div className="Row" key={index}>
                      <div className="Cell">
                        <span className="Txt">{name}</span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {dataLength > SEE_MORE_LIMIT && (
        <button
          type="button"
          className="SeeMoreButton"
          onClick={handleToggleSeeMore}
        >
          Show {seeMore ? 'less' : 'more'}...
        </button>
      )}
    </div>
  );
};
